define.alias("shared/components/shared/social-identity", "preview-grid/components/shared/social-identity");